export class Role {
    roleId: number;
    role : string;
    features : string | string[];
}

  